import React, {Component} from 'react';
import  AmountItem from './amountItem';
import WorthyApi from 'lib/api/worthyApi'
import I18n from 'lib/i18n/i18n';


class AmountList extends Component{
    constructor(props){
        super(props);
        this.state = {
            amounts: ''
        };
        this.getWorthyNumbers = this.getWorthyNumbers.bind(this);
        this.interval = I18n.getString('itemPage::trends::amounts::interval')
    }

    componentDidMount(){
        this.getWorthyNumbers();
    }

    getWorthyNumbers(){
        WorthyApi.getWorthyNumbers(this.props.itemId)
            .then((res) => {
                this.setState({amounts: res.data});
            })
            .catch((error)=>{
                this.setState({ amounts: error });
            });
        return setTimeout(this.getWorthyNumbers, this.interval);
    }

    render() {
        let types = ['sellers', 'bids', 'time'];
        let amounts = this.state.amounts;
        let worthyNmbers;
        if(amounts){
            worthyNmbers = types.map( (type, i) => {
                return <AmountItem key={i} type={type} value={amounts[`total_${type}`]}/>;
            })
        }

        return (
            <div className="worthy-numbers">
                { worthyNmbers }
            </div>
        )
    }
}

export default AmountList;


